export default __webpack_public_path__ + "static/media/main.2f71efe4.svg";